module.exports = __webpack_public_path__ + "static/logo-ad9e2e96bad553c732e358f33c0d44f1.png";